module.exports = __webpack_public_path__ + "static/img/AudioOn.185e485.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/AudioOn.png
// module id = i4hg
// module chunks = 1